<template>
  <div id="SheetPackages">
    <v-dialog v-model="open" persistent max-width="700">
      <v-card class="align-center text-center">
        <v-card-text>
          <div class="pt-5 d-flex align-center justify-space-between">
            <h1>Selecione sua planilha</h1>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <div class="mt30"></div>
          <v-file-input
            v-if="open"
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :label="fileNfe ? 'Planilha Selecionada: ' : 'Selecione a planilha'"
            @change="onChangeNfe"
          ></v-file-input>
          <div class="mt30"></div>
          <section
            v-show="fileNfe !== null"
            class="border-tab scroll no-border"
            :style="{ 'max-height': '520px', width: 'auto' }"
          >
            <xlsx-read :file="fileNfe" class="w-100-all">
              <xlsx-table :sheet="0" />
            </xlsx-read>
          </section>
          <div class="mt10"></div>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" large @click="close()"> Cancelar </v-btn>
          <v-btn
            :loading="loading"
            color="success"
            class="flex-grow-1"
            large
            :disabled="fileNfe === null"
            @click="multiple ? sendMultipleNfeSheet() : sendSingleNfeSheet()"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { XlsxRead, XlsxTable } from '../../../node_modules/vue-xlsx/dist/vue-xlsx.es.js';
export default {
  name: 'SheetPackages',
  components: {
    XlsxRead,
    XlsxTable
  },
  props: {
    open: {
      default: false,
      type: Boolean
    },
    nfeId: {
      default: null,
      type: String
    },
    multiple: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    message: {},
    fileNfe: null,
    loading: false
  }),
  watch: {
    open: {
      handler(isOpen) {
        if (isOpen) {
          this.fileNfe = null;
        }
      }
    }
  },
  methods: {
    ...mapActions('ShipmentStore', ['createSheetPackagesNfe', 'createSheetPackages']),
    onChangeNfe(file) {
      this.fileNfe = file || null;
    },
    close(hasChange, message) {
      this.$emit('closeSheetPackages', hasChange, message);
    },
    async sendSingleNfeSheet() {
      let newFormData = new FormData();

      newFormData.append('spreadsheet', this.fileNfe);

      this.loading = true;
      try {
        const status = await this.createSheetPackagesNfe({
          form: newFormData,
          id: this.nfeId
        });
        if (status.success) {
          this.message = {
            errors: ['Upload feito com sucesso!'],
            errorsType: 'success'
          };
        } else {
          this.message = {
            errors: status.errors,
            errorsType: 'error'
          };
        }
      } catch (e) {
        console.error(e);
        this.message = {
          errors: status.errors,
          errorsType: 'error',
          error500: e
        };
      } finally {
        this.close(true, this.message);
        this.loading = false;
      }
    },
    async sendMultipleNfeSheet() {
      let newFormData = new FormData();

      newFormData.append('spreadsheet', this.fileNfe);

      this.loading = true;
      try {
        const status = await this.createSheetPackages(newFormData);

        if (status.success) {
          this.message = {
            errors: ['Upload feito com sucesso!'],
            errorsType: 'success'
          };
        } else {
          this.message = {
            errors: status.errors,
            errorsType: 'error'
          };
        }
      } catch (e) {
        console.error(e);
        this.message = {
          errors: status.errors,
          errorsType: 'error',
          error500: e
        };
      } finally {
        this.close(true, this.message);
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
